import {setMessage, isVisible} from './message'
import {setLoadingStatus} from './loaderAction';
export const frontEndUserData = 'FRONTENDUSERDATA';

export const setFrontEndUserData = (data) => {  

  return { 
  		type: frontEndUserData, 
  		fetchedFrontEndUserData: data 
  	}
}

export const userEdited = (status) => {  

  return { 
        type: 'USER_HAS_BEEN_EDITED',
        status
    }
}

export const fetchFrontEndUser = (url) => {
	 return (dispatch) => {      
        dispatch(setLoadingStatus({reducer: 'FrontEndUserReducer', status: true}))
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;          
        })
        .then((response) => response.json())
        .then((data) => {
            //-- set clients data 
            dispatch(setLoadingStatus({reducer: 'FrontEndUserReducer', status: false}))
            dispatch(setFrontEndUserData(data))                             
            
        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan de gebruikers niet ophalen'})));
    };
}

export const addFrontEndUser = (url, postData, attached_addresses) => {
	let data = new FormData;
   
   
    data.append('postData', JSON.stringify(postData) );
    data.append('attached_addresses', JSON.stringify(attached_addresses));
    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FrontEndUserReducer', status: true}))
        fetch(url + '/api/frontenduser/action/addUser',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {       
              dispatch(setLoadingStatus({reducer: 'FrontEndUserReducer', status: false}))
                           
              dispatch(fetchFrontEndUser(url + '/api/frontenduser/action/getUsers'))
              dispatch(userEdited(true));

              dispatch(setMessage(data.message))
                
                
            })
            .catch((error) => {
                
                
            });
    };
}


// WEBPACK FOOTER //
// ./src/actions/frontEndUser.js